import { defineNuxtPlugin, useRouter } from '#imports'

export interface FeaturesPlugin {
  get(feature: string): boolean
  all(features: string[]): boolean
  route(path: string): string[] | null | false
  access(path: string): boolean
  readonly list: string[] | null
}

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()

  const plugin: FeaturesPlugin = {
    get(feature) {
      const active = nuxtApp.$auth.active
      const features = this.list

      if (!active || !features) {
        return false
      }

      return features.includes(feature)
    },

    all(features) {
      return features
        .every((feature) => {
          return this.get(feature)
        })
    },

    route(path) {
      if (!path) {
        return false
      }

      const resolved = router.resolve(path)
      const features = resolved.meta.features ?? null

      return features
    },

    access(path) {
      if (!path) {
        return false
      }

      const resolved = router.resolve(path)
      const features = resolved.meta.features ?? null

      if (!features) {
        return true
      }

      return this.all(features)
    },

    get list() {
      return nuxtApp.$auth?.info?.features
    },
  }

  nuxtApp.provide('features', plugin)
})
